<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="mb-3">
  <div class="row m-0 d-none">
    <div class="col-md-3 p-2 box" routerLink="/lms-dashboard/lms-loan-entry">
      <!-- loan-info -->
      <div class="d-flex box-container">
        <div class="box-img">
          <img
            src="../../assets/images/app.png"
            alt="img"
            class="w-100"
          />
        </div>
        <div
          class="d-flex align-items-center pl-4 pr-4 justify-content-between box-content w-80"
        >
          <span> Loan Entry </span>
        </div>
      </div>
    </div>
    <div class="col-md-3 p-2 box" routerLink="/lms-dashboard/lms-nach-entry">
      <!-- Nach-info -->
      <div class="d-flex box-container">
        <div class="box-img">
          <img
            src="../../assets/images/app.png"
            alt="img"
            class="w-100"
          />
        </div>
        <div
          class="d-flex align-items-center pl-4 pr-4 justify-content-between box-content w-80"
        >
          <span> Nach Entry </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row m-0 col-md-12 p-0 mb-3">
  <div
    class="col-12 col-sm-6 col-md-4 p-2"
    *ngFor="let item of dashboardData; let ind = index"
    (click)="getDetail(item.ShortName)"
  >
    <div class="lms-dashboard-card">
      <div class="lms-card-accent"></div>
      <div class="lms-card-body">
        <div class="lms-icon-wrapper">
          <img
            src="{{ iconname }}{{ item.IconImage }}"
            alt="icon"
            class="lms-card-icon"
          />
        </div>
        <div class="lms-card-info">
          <span class="lms-card-count">{{ item.ItemCount }}</span>
          <span class="lms-card-title">{{ item.IconName }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row m-0 col-md-12 p-0" *ngIf="dataSource">
  <div class="col-md-12">
    <h1 class="fs-12 m-0">Disbursment Details :-</h1>
    <div class="table-responsive mt-2">
      <mat-table
        [dataSource]="dataSource"
        matSort
        matTableExporter
        #exporter="matTableExporter"
        class="dashboard-disbursment-table"
      >
        <ng-container matColumnDef="Loan_Id">
          <mat-header-cell
            mat-sort-header
            class="grid-header mw40"
            *matHeaderCellDef
            >#</mat-header-cell
          >
          <mat-cell
            *matCellDef="let row; let i = index"
            class="grid-cell mw40 mh-5"
          >
            {{ i + 1 }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="mw40"
          ></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="Application_No">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            Application No
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Application_No }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="LoanAcNo">
          <mat-header-cell
            mat-sort-header
            class="grid-header mw85"
            *matHeaderCellDef
            >LoanAcNo</mat-header-cell
          >
          <mat-cell
            *matCellDef="let row"
            class="grid-cell mw85"
          >
            {{ row.LoanAcNo }}
          </mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="mw85"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="CustumerName">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Customer Name</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.CustumerName }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Product_Name">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Product</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Product_Name }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>Total:</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Application_LoanAmount">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >Loan Amount</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Application_LoanAmount }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>{{
            totaltypewise("Application_LoanAmount")
          }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="OpeningBalanceDR">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >OP Bal(DR)</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.OpeningBalanceDR }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>{{
            totaltypewise("OpeningBalanceDR")
          }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="OpeningBalanceCR">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >OP Bal(CR)</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.OpeningBalanceCR }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>{{
            totaltypewise("OpeningBalanceCR")
          }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="TranTypeDR">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >TR Bal(DR)</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.TranTypeDR > 0 ? row.TranTypeDR : "" }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>{{
            totaltypewise("TranTypeDR")
          }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="TranTypeCR">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >TRBal(CR)</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.TranTypeCR > 0 ? row.TranTypeCR : "" }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>{{
            totaltypewise("TranTypeCR")
          }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="ClosingBalanceDR">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >CL Bal(DR)</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.ClosingBalanceDR > 0 ? row.ClosingBalanceDR : "" }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>{{
            totaltypewise("ClosingBalanceDR")
          }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="ClosingBalanceCR">
          <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
            >CL Bal(CR)</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.ClosingBalanceCR > 0 ? row.ClosingBalanceCR : "" }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>{{
            totaltypewise("ClosingBalanceCR")
          }}</mat-footer-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <mat-footer-row
          class="sticky-footer fontcolor bg-primary-brand"
          *matFooterRowDef="displayedColumns; sticky: true"
        ></mat-footer-row>
      </mat-table>
      <!-- <div class="row m-0 align-items-center" style="background: #fff;">
        <div class="col-md-2">
          <button class="btn btn-success font-size-12" (click)="exportTable(exporter)">
            <i class="fa fa-file-export mr-1" style="font-size:medium;cursor: pointer;"></i> Export
          </button>
        </div>
        <div class="col-md-2">
        </div>
        <div class="col-md-8">
          <mat-paginator #paginatorRef [pageSizeOptions]="[20,50]" showFirstLastButtons> </mat-paginator>
        </div>
      </div> -->
    </div>
  </div>
</div>
